export default {
  stockTypes: [],
  stockType: undefined,
};
